import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import styles from '../styles/EditProduct.module.css';
//esse é o certo
const EditProduct = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState({
    nome: '',
    preco: '',
    potencia: '',
    polos: '',
    tensao: '',
    carcaca: '',
    estoque: '',
    marca: { id: '', nome: '', imagem: '' },
  });
  const [marcas, setMarcas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false); 

  useEffect(() => {
    fetchProduct();
    fetchMarcas();
  }, []);

  const fetchProduct = async () => {
    try {
      const response = await axios.get(`https://crmesquita.com.br/api/produtos/${id}/`);
      setProduct(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Erro ao buscar produto:', error);
      alert('Erro ao carregar as informações do produto.');
      navigate('/gerenciar-produtos');
    }
  };

  const fetchMarcas = async () => {
    try {
      const response = await axios.get('https://crmesquita.com.br/api/marcas/');
      setMarcas(response.data);
    } catch (error) {
      console.error('Erro ao buscar marcas:', error);
      alert('Erro ao carregar as marcas.');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProduct((prevProduct) => ({
      ...prevProduct,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true); 
    try {
      await axios.put(`https://crmesquita.com.br/api/produtos/${id}/`, product);
      alert('Produto atualizado com sucesso!');
      navigate('/gerenciar-produtos');
    } catch (error) {
      console.error('Erro ao atualizar produto:', error);
      alert('Erro ao atualizar o produto.');
    } finally {
      setIsSaving(false);
    }
  };

  if (loading) {
    return <p>Carregando...</p>;
  }

  return (
    <div className={styles['edit-product-container']}>
      <h1 className={styles['edit-product-title']}>Editar Produto</h1>
      <form className={styles['edit-product-form']} onSubmit={handleSubmit}>
        <div className={styles['form-group']}>
          <label htmlFor="nome">Nome do Produto:</label>
          <input
            type="text"
            id="nome"
            name="nome"
            value={product.nome}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles['form-group']}>
          <label htmlFor="preco">Preço:</label>
          <input
            type="number"
            id="preco"
            name="preco"
            value={product.preco}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles['form-group']}>
          <label htmlFor="potencia">Potência:</label>
          <input
            type="text"
            id="potencia"
            name="potencia"
            value={product.potencia}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles['form-group']}>
          <label htmlFor="polos">Polos:</label>
          <input
            type="text"
            id="polos"
            name="polos"
            value={product.polos}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles['form-group']}>
          <label htmlFor="tensao">Tensão:</label>
          <input
            type="text"
            id="tensao"
            name="tensao"
            value={product.tensao}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles['form-group']}>
          <label htmlFor="carcaca">Carcaça:</label>
          <input
            type="text"
            id="carcaca"
            name="carcaca"
            value={product.carcaca}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles['form-group']}>
          <label htmlFor="estoque">Estoque:</label>
          <input
            type="number"
            id="estoque"
            name="estoque"
            value={product.estoque}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles['form-group']}>
          <label htmlFor="marca">Marca:</label>
          <select
            id="marca"
            name="marca"
            value={product.marca.id}
            onChange={(e) => {
              setProduct((prevProduct) => ({
                ...prevProduct,
                marca: { ...prevProduct.marca, id: e.target.value },
              }));
            }}
            required
          >
            <option value="">Selecione uma marca</option>
            {marcas.map((marca) => (
              <option key={marca.id} value={marca.id}>
                {marca.nome}
              </option>
            ))}
          </select>
        </div>
        <button
          type="submit"
          className={styles['save-button']}
          disabled={isSaving}
        >
          {isSaving ? 'Salvando...' : 'Salvar Alterações'}
        </button>
        <button
          type="button"
          className={styles['cancel-button']}
          onClick={() => navigate('/gerenciar-produtos')}
        >
          Cancelar
        </button>
      </form>
    </div>
  );
};

export default EditProduct;
